module.exports = __webpack_public_path__ + "img/b.41a3d732.png";